import type { ReactNode } from 'react';
import { LabelWithValue } from '@/components/common/LabelWithValue';
import { formatDisplayDateTime } from '@/utils/date';
import type { PcmpProposalDetail } from '../../types/pcmpProposal.types';
import { PcmpProposalSection } from './PcmpProposalSection';
import { PcmpStatusPill } from './PcmpStatusPill';

interface PcmpInstituteCardProps {
  institute: PcmpProposalDetail['institute'];
  actions?: ReactNode;
}

export function PcmpInstituteCard({ institute, actions }: PcmpInstituteCardProps) {
  return (
    <PcmpProposalSection
      title="School"
      actions={
        <>
          {institute.isDeleted ? <PcmpStatusPill tone="danger">Deleted</PcmpStatusPill> : null}
          {institute.submissionStatus === 'REJECTED' ? (
            <PcmpStatusPill tone="danger">Submission rejected</PcmpStatusPill>
          ) : null}
          {actions}
        </>
      }
    >
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <LabelWithValue label="Institute">{institute.name}</LabelWithValue>
        <LabelWithValue label="Lectrack Code">{institute.id}</LabelWithValue>
        <LabelWithValue label="EIIN">{institute.eiinNumber}</LabelWithValue>
        <LabelWithValue label="Submitted">
          {formatDisplayDateTime(institute.submittedAt)}
        </LabelWithValue>
        <LabelWithValue label="Thana">{institute.thanaName}</LabelWithValue>
        <LabelWithValue label="District">{institute.districtName}</LabelWithValue>
      </div>
      {institute.submissionComments ? (
        <LabelWithValue label="Submission Note">
          <span className="whitespace-pre-line font-normal">{institute.submissionComments}</span>
        </LabelWithValue>
      ) : null}
    </PcmpProposalSection>
  );
}
